import { gql, useMutation } from '@apollo/client';

const QUESTIONNAIRE_DOWNLOAD_DOCX_V2 = gql`
  mutation QuestionnaireDownloadDocxV2($id: String!, $fileName: String) {
    questionnaireDownloadDocxV2(id: $id, fileName: $fileName) {
      mimeType
      fileName
      fileBase64
    }
  }
`;

export interface QuestionnaireDownloadDocxV2Input {
  id: string;
  fileName?: string;
}

export interface QuestionnaireDownloadDocxV2Result {
  questionnaireDownloadDocxV2: {
    mimeType: string;
    fileName: string;
    fileBase64: string;
  };
}

/**
 * Hook for downloading questionnaire as DOCX using the new HTML-first approach.
 *
 * This mutation uses locally rendered HTML (with snippets and translations) instead of
 * relying on legalOS DOCX rendering.
 *
 * @example
 * const [downloadDocx, { loading }] = useQuestionnaireDownloadDocxV2Mutation();
 * downloadDocx({ variables: { id: localQuestionnaireId } });
 */
export function useQuestionnaireDownloadDocxV2Mutation() {
  return useMutation<QuestionnaireDownloadDocxV2Result, QuestionnaireDownloadDocxV2Input>(
    QUESTIONNAIRE_DOWNLOAD_DOCX_V2
  );
}
